export const schema = {
  poolAttributes: {
    actionRequired: '5d7a853a3d2feb7bb8e7842f',
    quantity: '5d7a853a3d2feb7bb8e78430',
    unit: '5d7a853a3d2feb7bb8e78431',
    repairPriority: '5d7a853a3d2feb7bb8e78432',
    description: '5d7a853a3d2feb7bb8e7842e',
    repairRecommendation: [
      '5961c264-21c8-450a-be47-8c3bd794be22',
      '02123cb4-c185-493b-ad0c-cc1cfa8fa5fb',
      '4e73390d-4cf6-418d-bd6a-228dc043d6ae',
      '23b78ede-ae4b-48ab-8e03-aed881b462d0',
      'f51ec647-21f6-4f54-a84c-10401132c658',
      'dbf33fc7-8129-4d82-b95f-f809da268238',
      'a26fcb49-6e49-43f7-9dac-2c9a96f10ac5',
      'b2b9f4c2-5cf9-40d3-a044-51f5f1db6840',
      '3eb2a517-8ba9-4de3-a879-d45782c1b830',
      'f8984251-9474-4114-a015-6e70d05d7ee8',
      '5961c264-21c8-450a-be47-8c3bd794be22',
    ],
  },
  inspectionData: {
    inspectionDate: 'ecac8578-4bca-43a5-a7f8-656110c661c7',
    previousInspection: 'cdf23432-5f75-4db5-8ac2-b82e6f589938',
    previousInspectionDate: '9d4c3e6a-6be3-48ed-acaa-99e569e7c648',
    inspectionType: 'e5fb61eb-47d1-4a54-b74d-99417a80bf41',
    teamLeader: 'ec5c8e72-53f3-4352-a386-ca0b779aceee',
    otherTeamLeader: '83fc0f50-7576-4c68-b047-8d5311014973',
    inspectionTeamMembers: '2a0b6d3e-241a-4d3d-ad0b-61ba132d03c5',
    otherTeamMembers: '86faae71-00f8-4987-8e0e-0d3e79c272c2',
    overallConditionRating: 'd7ed1a7b-6392-4e4e-9091-e82802a32b77',
    recommendedInspFreq: '6dbda24e-1924-4f5f-8e3b-55c0ea742a47',
    specialAccess: '26430927-69fd-4687-a703-62e882136c4e',
    otherSpecialAccess: 'fa680229-8323-426f-8746-8210993cbf11',
    specialtyEquipment: 'cdd6a0d5-4afe-4fe5-813c-855e206fcdf6',
    otherSpecialtyEquipment: '69ffe482-d41d-4b1d-9011-9c05ea0c00bd',
    generalNotes: 'c59d41a0-626c-411e-a7fa-2db1f2c89c95',
  },
  generalData: {
    unitNumber: '1a5c0cf4-15b7-40a6-b90b-ea37bc1333b9',
    unitName: 'f9c9409f-baac-4776-b3f0-751904b21706',
    area: '804daed3-1df6-4c14-b68d-694b96680b26',
    nickname: '9b283bd6-3ba5-49e6-8617-98a3c185ce03',
    type: '9b099fc4-81d6-4a62-9098-0bf735eaeff1',
    numberOfPlatforms: 'a222354a-9589-450a-bf01-d2b0db044b51',
    loadingRestrictions: 'a8be2d63-acd0-4294-83b2-a889fd2f16fa',
    loadingRestrictionDescription: 'c74e35dd-e8bb-457d-ab48-e96962adcdf9',
  },
  hoistBeamTrolleyBeamData: {
    equipmentServingId: 'cefce82c-51c5-4707-9b74-69e1d0a3dac9',
    loadPostedOnBeam: 'e2edd728-1bae-4f55-bbf8-292dd1a15476',
    existingLoadPosting: 'f7db341e-7c7b-4811-8c68-5fc9c7cfad54',
    loadPostingUnits: 'dffe361a-5ded-4114-b928-c129b992f8b4',
    structuralDrawingSd: '32e90ddc-39cd-4d37-899e-90941ca95c39',
    memberSize: 'd9f47adc-bd9d-4935-a4dc-6152d76f54e4',
    dateOfLastLoadRating: '04a599f3-44e2-47cf-ac54-d38275680c6f',
    loadRating: 'cb7eae4f-13af-4ab6-81a2-c8434a83ec4c',
    overallLength: '7d11c8f0-595f-4493-aeb1-5e842da6c69d',
    maxSpanDistance: 'a0c60b17-85bb-4b2d-9ad5-91cd2598a7a5',
    maxCantileverDistance: '8721bc21-16da-49ab-bba6-85dbaa91ba6d',
    numberOfSupportsBeam: 'c113cc2a-fa63-4c37-8b4c-17e8134fafce',
  },
  pipeRackData: {
    typeOfPipeRack: '9cbdfdda-e377-464a-90fb-70583bae8dd2',
    startLatitude: '747c186f-ed7b-4ffc-bc98-866cbb094b4e',
    startLongitude: '24307a19-20cd-42ad-9d5b-2e1e59f330e0',
    startLocationDescription: '9c66b86d-e6dc-43e4-b3e9-877995614d41',
    endLocationDescription: 'bf5c40ec-f018-4697-991a-f34a29c05f66',
    numberOfSupports: '01ee0a6c-d0e4-4405-83ae-96a2e803df17',
    endLatitude: 'fe134197-0ff8-4111-8128-011b69de52af',
    endLongitude: '1076f643-d396-482c-a1b5-14e8d547aaf1',
  },
};

export const inspectionDataOrder = [
  schema.inspectionData.inspectionDate,
  schema.inspectionData.previousInspection,
  schema.inspectionData.previousInspectionDate,
  schema.inspectionData.inspectionType,
  schema.inspectionData.teamLeader,
  schema.inspectionData.otherTeamLeader,
  schema.inspectionData.inspectionTeamMembers,
  schema.inspectionData.otherTeamMembers,
  schema.inspectionData.overallConditionRating,
  schema.inspectionData.recommendedInspFreq,
  schema.inspectionData.specialAccess,
  schema.inspectionData.otherSpecialAccess,
  schema.inspectionData.specialtyEquipment,
  schema.inspectionData.otherSpecialtyEquipment,
];

export const generalDataLeft = [
  schema.generalData.unitName,
  schema.generalData.area,
  schema.generalData.nickname,
  schema.generalData.loadingRestrictionDescription,
];

export const generalDataRight = [
  schema.generalData.type,
  schema.generalData.numberOfPlatforms,
  schema.generalData.loadingRestrictions,
];

export const pipeRackLeft = [
  schema.pipeRackData.typeOfPipeRack,
  schema.pipeRackData.startLatitude,
  schema.pipeRackData.startLongitude,
  schema.pipeRackData.startLocationDescription,
];

export const pipeRackRight = [
  schema.pipeRackData.endLocationDescription,
  schema.pipeRackData.numberOfSupports,
  schema.pipeRackData.endLatitude,
  schema.pipeRackData.endLongitude,
];

export const hoistBeamLeft = [
  schema.hoistBeamTrolleyBeamData.equipmentServingId,
  schema.hoistBeamTrolleyBeamData.loadPostedOnBeam,
  schema.hoistBeamTrolleyBeamData.existingLoadPosting,
  schema.hoistBeamTrolleyBeamData.loadPostingUnits,
  schema.hoistBeamTrolleyBeamData.structuralDrawingSd,
  schema.hoistBeamTrolleyBeamData.memberSize,
];

export const hoistBeamRight = [
  schema.hoistBeamTrolleyBeamData.dateOfLastLoadRating,
  schema.hoistBeamTrolleyBeamData.loadRating,
  schema.hoistBeamTrolleyBeamData.overallLength,
  schema.hoistBeamTrolleyBeamData.maxSpanDistance,
  schema.hoistBeamTrolleyBeamData.maxCantileverDistance,
  schema.hoistBeamTrolleyBeamData.numberOfSupportsBeam,
];
